export default __webpack_public_path__ + "static/media/img1.14792db9.jpg";